import { forwardRef, useMemo } from "react";

import classNames from "classnames";

import { PhoneInput } from "react-international-phone";

import { isEmpty } from "../../utils/validators";

import "react-international-phone/style.css";

const PhoneField = forwardRef((props, ref) => {
  const { name, label, value, disabled, options, required, error, ...rest } =
    props;

  const labelMemo = useMemo(() => {
    const reqLabel = required ? "*" : "";
    return [label, reqLabel].filter((i) => !isEmpty(i)).join(" ");
  }, [label, required]);

  const titleMemo = useMemo(() => {
    return `${label} - ${value}`;
  }, [label, value]);

  const classNamePrefix = "phone-field";

  return (
    <div className={`${classNamePrefix}__container`}>
      <div
        className={classNames(`${classNamePrefix}__content`, {
          disabled: disabled,
          invalid: error,
        })}
      >
        <label
          htmlFor={name}
          className={`${classNamePrefix}__label`}
          title={labelMemo}
        >
          {labelMemo}
        </label>
        <PhoneInput
          {...rest}
          name={name}
          disabled={disabled}
          required={required}
          value={value}
          className={`${classNamePrefix}-input-container`}
          title={titleMemo}
          inputClassName={classNames(`${classNamePrefix}-input`, {
            [`${classNamePrefix}-input--disabled`]: disabled,
          })}
          countrySelectorStyleProps={{
            className: `${classNamePrefix}-country-selector`,
            buttonClassName: classNames(
              `${classNamePrefix}-country-selector-button`,
              {
                [`${classNamePrefix}-country-selector-button--disabled`]:
                  disabled,
              }
            ),
          }}
        />
      </div>
      <p className={classNames(`${classNamePrefix}__error`, { show: error })}>
        {error}
      </p>
    </div>
  );
});

export default PhoneField;
